let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c1t91")).then(() => parcelRequire('5X1X6'));